"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeperateLine = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Spacer_1 = require("./Spacer");
var colorLine = {
    primary: ['br-text-blue-600'],
    gray: ['br-text-gray-600'],
    orange: ['br-text-orange-600'],
    red: ['br-text-red-600'],
    // How to give a specific name to a color?
    blueGray: ['br-text-[#AEBFD4]']
};
var SeperateLine = function (_a) {
    var className = _a.className, type = _a.type, _b = _a.spaceWidth, spaceWidth = _b === void 0 ? 1 : _b, props = __rest(_a, ["className", "type", "spaceWidth"]);
    var cns = colorLine[type];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Spacer_1.Spacer, { w: spaceWidth }),
        react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)(className, cns) }, props), "|"),
        react_1.default.createElement(Spacer_1.Spacer, { w: spaceWidth })));
};
exports.SeperateLine = SeperateLine;
